
    import './styles.scoped.css';
    export default {
  "container": "awsui_container_6umcw_d7u8j_5",
  "cards-list": "awsui_cards-list_6umcw_d7u8j_9",
  "card-header": "awsui_card-header_6umcw_d7u8j_13"
};
  